<nz-tabset [nzSelectedIndex]="selectedIndex" (nzSelectedIndexChange)="onTabChange($event)">
  <nz-tab
    nzTitle="Build Chart"
    *ngIf="appService.isEngagementActive && authService.hasEntitlements(viewBiRelatedTabs)"
  ></nz-tab>
  <nz-tab nzTitle="Manage Charts" *ngIf="authService.hasEntitlements(viewBiRelatedTabs)"></nz-tab>
  <nz-tab
    nzTitle="Create Dashboard"
    *ngIf="appService.isEngagementActive && authService.hasEntitlements(viewBiRelatedTabs)"
  ></nz-tab>
  <nz-tab nzTitle="Manage Dashboards" *ngIf="authService.hasEntitlements(viewBiRelatedTabs)"></nz-tab>
</nz-tabset>

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
